import { render, staticRenderFns } from "./vintrotext.vue?vue&type=template&id=09876444&scoped=true&"
import script from "./vintrotext.vue?vue&type=script&lang=js&"
export * from "./vintrotext.vue?vue&type=script&lang=js&"
import style0 from "./vintrotext.vue?vue&type=style&index=0&id=09876444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09876444",
  null
  
)

export default component.exports